import { render } from "./Single.vue?vue&type=template&id=7139d250&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import "./Single.vue?vue&type=style&index=0&id=7139d250&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/production/goodedition/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7139d250"]])

export default __exports__